import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'backslash', 'Backslash', [["path",{"d":"M7 5l10 14"}]]);